/** Prefixed to the field label so the toggle's accessible name tracks label copy edits for free. */
export const HINT_TOGGLE_LABEL_PREFIX = 'About';

export const HINT_VISIBLE = 'mt-2 text-body-xs text-content-secondary';

export const HINT_TOGGLE_CLASS = 'cursor-pointer text-content-secondary';
